/*
How this list was made:
1- download https://github.com/danielmiessler/SecLists/blob/master/Passwords/xato-net-10-million-passwords.txt
2- to reduce size, apply sh command to remove all passwords that don't match our rules

out of 10 million passwords, we got a list of ~2500 passwords that are common or insecure
*/

export const InsecurePasswords = [
  'Al#kS3!kSj0xX',
  'Qwerty1!',
  'Password1!',
  'gNdb4b3$',
  'Samantha1!',
  'Marco1997!',
  'Juninho1999@',
  '$Tatyana09$',
  '!QAZxsw2#EDCvfr4',
  'u@eLy2y6u#erY4',
  'taQU5ybY5e#YbA',
  'sUtY8yLaDyhe!A',
  's5j1Ko6Sa#',
  'm#XI!RZYvh681=Fn',
  'gAgY4UzA%EAQu',
  'afRu0dYen!1z',
  'Zachary1!',
  'ZXCvbn123!',
  'Yr7$jiRO',
  'w3Ymb8f$fhr',
  'olki1H%ig',
  'VqGbShD5BmMw$Lup',
  'Vc19uNO3o!p',
  'V6#nsBLDES2!7Zg',
  'Sj2323!!',
  'Simpsons1#',
  'Passw0rd!',
  'Number123456789!!!',
  'Money4me2!',
  'Jonbm86!',
  'Jesus777!',
  'Jerk921@',
  'J33p3rs!',
  'Fuckyou123!',
  'Fuck0ff!',
  'ETaQaTeve2A#y2',
  'DFj8979789!ths',
  'Buster123!',
  'Bradley1!',
  'Bomber52!',
  'Black2055!',
  'ASdf12#$',
  'A5ezygyJa4y#eL',
  '3SKpil#C!1=62ehH',
  '3Lgn5!9IMBHb',
  '!Fish72!',
  'zyquXYZuhe6E$e',
  'zweRTfc5N4n7u6#q',
  'zMy7D$YTfP',
  'zI8Flp4H1a!',
  'zG0Te19L8#kf_u3',
  'z90X_#5tba3O4!Ag',
  'z#D3NvEw0H!ou_nK',
  'yvygU7yDa5usu#',
  'yuliaogaJo1!',
  'yrEzejyMe3A#a%',
  'ygeDua6y$udY3',
  'yZ3ndbc*9w$G',
  'yVJI2szg2t%z',
  'ySYmYVy6yBUSY#',
  'yReqEBE8ySADA#',
  'yQunA4eGu6e5e#',
  'yN4*ufZjdo4*OC#U',
  'yMa2a6U#yhu3az',
  'yHe8UQe6eNU!uB',
  'yHESaUTEsU2E$',
  'yDu$e8ezuQu#Eq',
  'y9R@z46oMNzF!Qy-V99X',
  'y9B0b.1303$Hf.611',
  'y4EbAte2a#A8yM',
  'xvtwj*kS2ho8bU$Y',
  'xk#w65F8v0!bA2Ku',
  'xbfA2rt_b1Su!',
  'xXH!ftc954V_s3j0',
  'xzT8t!F$0',
  'xV9#C5ZHb1l34_2O',
  'xS7hs9!sk9',
  'xK7zZ4B$',
  'xBvc#39!DkKT0_1',
  'x7fOpM4gwD8ZK_!3',
  'x$AHc7U*V23N',
  'x!Sm6E0u1l#bT72',
  'wyCkXu5$gJQ',
  'wnHz1!QoAlP8X7_0',
  'wZ!Yz82skD_#u1V7',
  'w6JDb.13298$5F7.4550',
  'w5Z9d.19377$sY3.17378',
  'w#YNl2izko4DPy_V',
  'vtlSVfmdu!53qkQ#',
  'vU$ELeDARa7Y!U',
  'vEzEta8y@yRYra',
  'vC5!48_2VOLi9#m1',
  'uzY9y5Ugy#u5Ep',
  'uzEne5UmY6AzU$',
  'utu3UzY5u$A5EJ',
  'utSqf7$VMwkp',
  'uqAnULaJE6a?',
  'upesU7EbY8E#A#',
  'umyQU8y7a6y#UQ',
  'uha%U5ePe3aSE#',
  'uZatyEDA5uHU!',
  'uZa9EQura$uaN',
  'uYGFnxSsRofMB3$H',
  'uXa2U$agA$U5Uq',
  'uXQUp7$keHhR',
  'uSu5YA#u!y5ut',
  'uRwJD9$veoGU',
  'uQaJu2E!UpY3US',
  'uFaTC183n-bk4tc#1',
  'uBu2E9y$uHeSuL',
  'uBYzE6a3ERA!aj',
  'u5uBuMAMAQa4u$',
  'u57w8!5Dg!B4@b^yVauH',
  'u$U7aDUrEQU5e!',
  'u#Y3a@U6UDyru@',
  'tedYse6eta#A7A',
  'te3SHk_!LJB4#f6R',
  'tZiMsbQxV2PR$GXj',
  'tYPa5e#A3EsY#Y',
  'tYLAqE9A#apaMA',
  'tU#aGyQy9A#YZU',
  'tEj2ruG$',
  'tENa3UQA@ebepy',
  'tCYdw9$Lm',
  'tABUpAYZY9U@a',
  't6gyhf&Pa3!',
  't2DkmU!N4S#AXI3z',
  't#2i1wZNf9Q_5e6J',
  'syDABa9E8APE#u',
  'svT5U&2#OtLqVDCFC8c!e',
  'sonLine10!',
  'slDkb.3791$S52.2284',
  'sXQ6bA#_8j!02SB',
  'sU6ahy9Y@AMeXu',
  'sQ!tR4dny_v',
  'sM2K_E397l1QvB!6',
  'sI9AE1q5N0#!Xylp',
  'sAtbpb4u$!',
  'sAsyZY5U#eBAju',
  'sARu8a3u9u!a2u',
  's@KB%AnQX8@z',
  's96HxV4!',
  's4mB#hCjF5R&g1',
  'ryDu8y8YtuLU%Y',
  'rQgq4H$x',
  'rEBAqUTu4a3a@u',
  'r8o_A4z0Q!7m',
  'r3Dt0n1c!',
  'qx6%a.808$Ps5.97805',
  'quagMire6!',
  'qToza.2627$4G.1040833',
  'qAg#U624_9S!ZE3x',
  'q9&EZTrq#tzE6J2k*v',
  'q4$Ra&D3DMTZ*bp72VVj',
  'q39V7hw2K4n85!cY',
  'q!Exrzg6Le#Hwu_t',
  'pxNK!s9w!',
  'ptTr$ZEUoh7*',
  'p_hie!2UyP9#cvOx',
  'p_0Xy8b1!M2cQ4Io',
  'pYTe9a#ahe!aGA',
  'pPkY5$qojnMVeJhQ',
  'pLhl33t@',
  'p?L9d2?7',
  'p9*J@X#N8q4s78gGM^',
  'p%E5p%E5p%E5',
  'os1#fcwrhFx0!5i',
  'oYga@rK?a?G@d51h*!Zd',
  'oYHq2x1X3vO#6nQC',
  'npBPJuSGw5!',
  'noNo11!!',
  'nYbYase9a9A%U',
  'nT5*e74$',
  'nSts1$29alt1',
  'nJi08sdF$5',
  'nBv9#036;tba',
  'nAncyPearls87!',
  'n9Rc_2L!l5wQ',
  'n9!g3PFm6fZE8Jj#',
  'n5#!ZG30BeHl4_t8',
  'n4dKq!_StX67Tij#',
  'n!45kxHm89#_CJYh',
  'moFo182$',
  'meGusta12$',
  'm_7Sp#zy5!3IR2qi',
  'mRlIff342!',
  'mJag$R6w*5',
  'mIamI137!#&',
  'mG87Nky!f9P6v4d_',
  'mAts0987!@',
  'mAqAe9e$Uny9y',
  'm20Br85@',
  'm$p0Dp*UDjhy2pDf*$$u',
  'lSdfc.13151762$Of.2191742',
  'lLQ9x364h!HwF5py',
  'lHNfS!4#g20EvtbT',
  'l4Ln3x6@OZ',
  'l11Spoty05!',
  'l0A?dcb1N*g',
  'koEkuMa67tyq%',
  'ko0m8!6#ORjs5nu_',
  'kl7!5FEy0h#zud3p',
  'kjXZa.7763$M6.585265',
  'ka#t6o1_BUA4i83!',
  'kMj137$7',
  'kKs12k826&12',
  'kD*%y54m*e$w',
  'kAudzZvqopLT2b$C',
  'k1K!k1K!',
  'k*49$Jl5b$mJ',
  'jx7HRoBe9K$',
  'jwHv9rbfTY$G',
  'jn1DvV5!cd72tyLQ',
  'jldZa.3077$Ih1.1288838',
  'jhdjAf918&23$',
  'je#yu7e#aJa!Y',
  'jaQeLAtU2a$Aty',
  'jaFAje_hA8Uy&kup?3#R',
  'jQ_6fh2JP!k5Dr#1',
  'jK4#a6!S',
  'jErCYu195F!_qD0T',
  'j7wIp0139!',
  'j0E4e.2044$Xi4.1076',
  'iltAdy2?',
  'ifeGoMuT2$LQ',
  'iMAGine79$',
  'iFwTJC2h@JOGNONLINE',
  'hr0G3g_eKp7!L#86',
  'hpP#!c972_SIMLu',
  'hg9#ZP_GpV1q!8d7',
  'hc5Ya.238$R6.100881',
  'hannibalHas0!',
  'hXJvHc$kqa3pN*tT',
  'hUe75cs!_34l',
  'hHwe38zU;veJE?af',
  'hDdxf00eV!!',
  'h2FAv9Lb!',
  'h!0_aAl1#32PUrjB',
  'guTTyke1!',
  'gqsKCJpNob6T$YF3',
  'goHokie5!',
  'gn0#S2exz8I_4Clb',
  'gelEg00p%',
  'gMNYa.31503$an6.1103900',
  'gHg4kJ&834',
  'gE9paiw0T!h72e6v',
  'g7U#aB29*',
  'fuckMe2!',
  'frOg2!00*',
  'fiGbb.2870$JM.3009806',
  'fXkQebqM2C$pZizG',
  'eu64V!v3_rFl',
  'epV6*akXd$b3j!5Y2m2b',
  'epU3e3aVymy#aQ',
  'epL6Nw7oYyr$5Q9c',
  'emeTAJeRa4u%yH',
  'elKab0ng!',
  'egI!5UBp#ujQdA7_',
  'eg3DQJuzx4$k',
  'e_DAw!U13dZO0#g6',
  'eZobens53!',
  'eTYry3uZeha@e8',
  'eSUra8Y@eDUzAt',
  'eRAqu7YHubaSY#',
  'ePE5eTybE%E2U$',
  'eMyd0c$123',
  'eLequ2UPudevy$',
  'eDucaTion9!',
  'eDM0b.1631$mm4.409',
  'e9Q5f9bR%ahucvEakfR',
  'e6KoV8Z!m2xaAcO',
  'e3Y8y6UnU7a$eN',
  'e#Useu7A$uZEL',
  'e!0M429v5c13#kA8',
  'dygA7uQaTe3Y$',
  'dp7UjS6z$wqLciHT',
  'dh9*D7hd&D9*(&',
  'da&FKVZx7d!R8KPeGAh0',
  'dRx@3U$GbXcQ',
  'dQ@Hh81f@flKJp',
  'dJ3!#U2tRGMh718_',
  'd5Hs98Mc!',
  'ch3Oa.9194$ZT5.7541',
  'cJMi$D6Ea7*w',
  'cF#0_z5!CEn4tQk3',
  'c7wvPrS20!U_DFt#',
  'c38j_V#v24Y!LGl',
  'c2Z_4Pdugk5AN!0l',
  'c271Al7!y',
  'c!rX6P#ANv7#',
  'c!iEG1JeYK5R3_N#',
  'by@aLu7A#AGEjE',
  'ba7YzeRA6UGu$y',
  'bGV8q6fV72!l9G',
  'b@LL3r88$',
  'b6Pn8T$LkAB',
  'b186zFexLh_0gGj!',
  'b0K!2ry7z6_l',
  'avyJaHy7u$EGUV',
  'auGl0bal!',
  'atZh0ok!',
  'as2SD7q9$',
  'aq1S@de3FR$',
  'apybAMyXE3e@Yj',
  'andrew&Hjd56$',
  'anaVa8a#A6E3u',
  'abYma5e5a#EMYz',
  'abA5aMeGuqu4y%',
  'au3u!EVyhaHYr',
  'aVuy6yNeTe!aJ',
  'aUop56x$nrVf',
  'aSAzatu2ujYhA#',
  'aRxoPJzu7p29$sAw',
  'aRxoPJzu7p29#036;sAw',
  'aPajEpURuRe5y#',
  'aMe5aZY8a@upEh',
  'aM2Ev138uw#6Czx!',
  'aKLJ2mC7?',
  'aIbjd.278492$35.12850982',
  'aHEPEmaDu6U%uR',
  'aHDistw1!',
  'aGYme4aSu#EreX',
  'aBAZa9A!UHy6YG',
  'a7EgU4u!aRAXEJ',
  'a6e$eJa5ESE$YB',
  'a3asaumY8aQA%',
  'a3ay6e5Y3ESa%',
  'a3AdyJY3AGY4e#',
  'a#egYhY9U$YSeX',
  'a#eRu8YRY#uLy5',
  '_nRm6L4!lFMN#kC2',
  '_Yx_b.1199$Bu1.215',
  '_V7!3zN1HgG2#6Ex',
  '_RKt!8PBDblv6u#f',
  '_OCs!JNgH1wS#4nL',
  '_O2DnGc73XQ6Zag!',
  '_MOB!Xna3#7y5QV1',
  '_FuN3!7GUd0nz4V8',
  '_AfvI7SPe!',
  '_3V2Gi8vT5Kk#p!',
  '_16R3cqI!zZmLS0#',
  '_15OwN0BAb8s!KqP',
  'ZzR4HXUeKx$',
  'ZzPgE23y$Dvr',
  'Zxcaq1@w',
  'ZtU3#vYjG$',
  'Zsw23$rfv',
  'Zs12345!',
  'Zont!123#',
  'Zmrzl1na!',
  'Zm$K23aihH*4qJEc',
  'Zima1979!',
  'Zim52115#',
  'Ziggs05!**',
  'Zidane04!',
  'Zep4Evr!',
  'ZenDanFaj25!',
  'Zballa24!',
  'ZbR#VI_c3myf8!z2',
  'ZaqwsX7679bgHrty!',
  'Zaq1xsw@',
  'Zaq1!qaz',
  'Zanfan01!',
  'Zachispro1!',
  'Za!rOQ7_#I9PG48D',
  'ZRCue2fc$pX4',
  'ZEZgEwQq1x!&amp',
  'ZAZEu3uNa%YNy',
  'Z8g749kc!!',
  'Z7zO2b5=mF#31eJT',
  'Z5w#q7J&',
  'Z1yth2um!',
  'Z#ji6sk5_3Lc01VO',
  'Z!1RsA4J6g9#B8ui',
  'YzU7U#e2eMABam',
  'Yv487Xw598#',
  'Yul609!PdwIvfR3_',
  'Yourelt5!',
  'Yomon1998!',
  'YnaXy2E7atyPa$',
  'Yk8$98bKxdCxp#',
  'Yip6z5nfB_9o!2L',
  'YgUbYTy5e$ubAm',
  'YdareQYDE8A%AT',
  'Yd#!bcg6P_Ik9lO',
  'Yay1nt3rN3ts!2',
  'Yankees1!',
  'Yamaha88!',
  'YXy8aZYqA$A9yH',
  'YeVE4eBUXuvY$',
  'YULqbdV5nFj@agh',
  'YNyty@e9ELu@uX',
  'YNeMUhE4a2Y#uv',
  'YNY6YpAsu7yMu$',
  'YJqxcXsNHV$2*SmC',
  'YGuXA4AXAjY%at',
  'YGuJE8y4E6u@Ap',
  'YGU6eXyHE4AJu%',
  'YDutU7eqU8a#u7',
  'YDUZU7y3eQeqA#',
  'YDAPy2y#epaNym',
  'YByXa6uhe#YNEg',
  'Y@nk3y!@',
  'Y7uvagy5ury$E6',
  'Y3s3C2A0n4$8',
  'Y0u8FutUr3&',
  'Y$ueBYPe9u#aQ',
  'Y$e6a$EdU6agyP',
  'Y#AGAXEDe$U6E#',
  'XypAtujuna2E@a',
  'Xylo45t!',
  'Xvkal12&%#',
  'Xsw2@wsx',
  'Xmas200&',
  'Xm77868!KMX878',
  'Xkueswnn1!',
  'Xerriah31@',
  'Xbox360!',
  'Xbnf*61!',
  'Xalema09?',
  'XZjyo9i$',
  'XYZabc98!!',
  'XR8zdZ95bwB$',
  'XJ28_63y5#1Ze!Na',
  'XFj58bMe*QD@',
  'X&t%$ffalk1@#',
  'uZa3Y@u2y4Edy',
  'uVAMy4y%aXe$e',
  'euMypyE2y$U',
  'd0q#2!QP6z9H=XV',
  'a6A#YhyByta%U',
  'QJk93GwmH$f',
  'BQew5l_1a#7mLXx',
  'Ayne69!!',
  'AwE4A$PAf3d2pu',
  '325_N79hJfIi6H#',
  'Voodoo1!',
  'Vo5jPJxH$ZXw',
  'VnJ901ID28_!6c75',
  'VkAnan-6!',
  'Vit2497!',
  'Virginia1!',
  'Viku1314@',
  'ViFt*q7A$293',
  'Vfvekz1@',
  'VfB1893!',
  'Varga0626!',
  'Varekai5!',
  'Vallejo94590!',
  'VaSA7yDyVY$eVY',
  'VaFinest27!!',
  'VAn3rd85!',
  'V8ioj#04R72Tq!1S',
  'V8#l6PQhK_29!74g',
  'V7T0k6jENBP!vHoz',
  'V3rh3l$t',
  'V3g1t@11563',
  'V#jXFPb5_fkh1AHK',
  'V!p3r_69',
  'Uza6EJY$uvUnyd',
  'Utu2eRYdUPE@ag',
  'Usselika12!@',
  'Useless123!',
  'Uryze2EvEQAby%',
  'Ury8aRu4ata$A$',
  'Uriel15!',
  'Urafool7!',
  'Un42n8ly123$',
  'Un1corn$',
  'UmaZa.7828$8O2.75493',
  'UmaBY4Y3A$ydyj',
  'Ujv4oaUJ!',
  'Ujnjdbnm19?Gjlcdtxybr66',
  'Ui$d@go32_UgdR',
  'Uhb6@sd3',
  'Ufpbr6996@2279',
  'Ue#51P8j_lDtuN6y',
  'UdA2u4e#a8EJur',
  'UbeXy9YE$yJy4',
  'UbAHUNy6A@UMet',
  'UXAhu8ASUZe6y#',
  'UYZanAqA8Y@ah',
  'UVYLEqyBA6UDy%',
  'UVYa.34568$jL2.2430241',
  'USetheforce23@#',
  'USa8ezebUsA2u#',
  'USArmy1181!',
  'UQEtA3A#EHU6as',
  'UNCjrT8!',
  'UJe4U8Y@e@UHUL',
  'U9u8y6aRU%ELUN',
  'U7ybY6Yve6U!e2625784',
  'U7_nv6!J9Cl',
  'U7AbYTA2YDyTu#',
  'U6w4_s#Z731p!K8',
  'U4u3y!yRYMUbe2',
  'U3YtY#a7e!U9a!',
  'U2A$eDu5A%YjEs',
  'U%ujU7udA3ASA%',
  'U#uDe8YuTEHE!',
  'U#dFq5PM3_8x9G7N',
  'U!U4aRANa8U$Em',
  'Tyrik123@@@',
  'Tyler1995!',
  'TyBalt123!',
  'Two4one!',
  'Tuulenvaarti1!',
  'Tundra1!',
  'Tryme1996!',
  'Truffle01@11',
  'Trlmm1835!',
  'Trident96!',
  'Trav3l$tar',
  'Trac3y1!',
  'TrE3$5cbd',
  'TrCRER7H@a57',
  'Tq53Fpv6Ldav1d!',
  'TpI4CbDbDc!',
  'Tp14@mf5',
  'Toupie123?',
  'Toshiba1121!',
  'Toronto2013#',
  'Torex311!',
  'Tony83$#',
  'Tocca-11!',
  'Tiwawas13!!',
  'Tinhyeu12!',
  'Timur23!',
  'Timpw4N!',
  'Thunderstorms1!',
  'Thomas1#',
  'Theduel3260599@',
  'Thebot14!',
  'Thales7165!',
  'ThaleS?90?',
  'Th3endccc!',
  'Test123$',
  'Terminal1!',
  'TeenTour49!',
  'Td0033$$',
  'Tc5U3q!RH0t',
  'Tb3@eeg44',
  'Tax!000!',
  'Tasj0408!',
  'Taras13!',
  'Taobietbb4everlacuataoday!!',
  'Tanker3$',
  'Tanka123456!',
  'Tanka1234!',
  'Tanganyika67!',
  'Tane4ka18021987!!',
  'Tad3Sur4#',
  'TUVAXy@E2ybE%U',
  'TTy!7485_dh',
  'TQwdpf!8_7J5k6M',
  'TNyGgMnE7Ht$',
  'TMnaU8J4FDG$',
  'TIger5161!',
  'T@rheel1!',
  'T@ni@3004_k',
  'T@dp0l31!',
  'T4aNpw66@DGC',
  'T3a2m1muz!',
  'T0rnad0s!',
  'T0kid0ki!',
  'T%TYa.2950$u44.2502',
  'Syzyjk1!',
  'Swo4life#1',
  'Swish23!',
  'SweetSummer1!',
  'Sweet4u!',
  'Sw0rdf!sh',
  'Superman41!',
  'Super072@@',
  'Sunsh1n3!',
  'SunnyD2854@',
  'Sunilpraj1!',
  'Sunfire23!',
  'Sun5h!ne',
  'Sumo01!!',
  'Summer312#',
  'Summer12!',
  'Subrat@123_1230879',
  'Student3#',
  'Stretch1!',
  'Straat70!',
  'Stir314!',
  'Stalker1977!',
  'StAr1954sTaR!DGC',
  'St8?1nyl',
  'St3v3@C@',
  'Sr87P%kR201U%1',
  'Squarez55!',
  'Sq9I!y8kR_xTKZP',
  'Spencer1!',
  'Spanky1!',
  'Spadaj123#',
  'Sp73jd3P!',
  'Sophie66!',
  'Soccerb0y!',
  'Soccer10$',
  'Snowball1!',
  'Snickers1!',
  'Snapscan21!',
  'Snacka2!',
  'SnS4Years#',
  'Smideshopen31!',
  'Sm145236@',
  'Sjh1230?',
  'Sjeng66@',
  'Sizers4$',
  'Silver_chair94!',
  'Signal77!',
  'Siemens12345$',
  'Shotgun7!',
  'Shooter1!',
  'Shmups9!',
  'ShiuKong1!',
  'Shit7448!',
  'ShipMate41!!',
  'ShawnKay16!',
  'Shannon81$$',
  'Shaman_123!',
  'Shadowbuilder69!',
  'Shadow1!',
  'ShadoeKree16!',
  'Sh4dow@!',
  'Sepo4k@1',
  'Senn448!Naga',
  'SellingSilver1!',
  'Selene21!',
  'Secret2!',
  'SeS1lja?',
  'SeAttle!06*',
  'Se2U4ebE$EbaqU',
  'ScumpaMea88!',
  'Scooter3!',
  'Scazip1%',
  'Sc913610!',
  'Sb38Vg$p',
  'Satka747474!',
  'Sass13god&^',
  'Saskiag60!',
  'Sanpai8957!',
  'Samsung1!',
  'Salinaildcat12$',
  'Sagovendor1123!@#',
  'Saartje04!',
  'S_8v2Yk4ePVjq#!',
  'SUr63gH9k@mpnPV',
  'SU$e3E$eSuhupy',
  'STompJJ71!!',
  'ST@cy261197!',
  'SSGVAndyU22@@',
  'SIUn73hdb&G&bvhj3d',
  'SIM0b.1634$ll4.74',
  'SFrj8$$$',
  'SFjnfd945!xo',
  'SDkpn175@',
  'SC5ZfpR67g#!21n4',
  'S9hJ0X#!Y_lLg1U2',
  'S3e14#fF',
  'S1s2s3s4s5s6!',
  'S1m0nqaz!',
  'S0n4t41!',
  'S0fanr0s!',
  'S!p*4R7X$',
  'S!lo294wrqL#HV_e',
  'Rz9$iloveyou',
  'Ryan1982!',
  'Ry8a5yduZEbu#a',
  'Ruslana2#',
  'Rush2!!2',
  'Runntaho77!',
  'Running1!',
  'Ruhr2010!',
  'Ru88er$$',
  'Rt5000539!$!',
  'Rt12ep8ve61$',
  'Ros160168!',
  'Rody666!',
  'Rodin197&',
  'Rockie11!',
  'Rockadile12!',
  'Ro8@as83!',
  'Rjju7kb@jampony1',
  'Riola06@',
  'Righton1!',
  'Richking08!',
  'Ri0204$06',
  'Rhlrod123@',
  'Rhebok12!',
  'Rg43w2t#A=Nbj16V',
  'Rg43w2t#A',
  'Rfritz74&nbsp',
  'Rfnthbyf0027!',
  'Rf2013!Rf',
  'Ren67v@yah',
  'Remedy42$',
  'Relhzi0d_!',
  'Relacom_2_2@hotm',
  'Reinis99!',
  'Rei1415!',
  'Register2011!',
  'Reggie06!',
  'Reed@flOER*890-',
  'Redsox11!!',
  'Redbull1!',
  'Rec0nmar!ne',
  'RealG123$',
  'RdR2015!',
  'Ravens1!',
  'Randen10!',
  'Rainbow1!',
  'Radhee12!',
  'RZsF6$tybkfx',
  'RYfpfhjd77!',
  'RY9u8YBU!AdE7A',
  'RFu3p1!nU542V',
  'REnna3L1$$',
  'REIZENxc3xa0&',
  'RAchele15!!',
  'R8!tzmtRB7m*x&za',
  'R7bLa.307323$3C2.8476160',
  'R45put1n!',
  'R41Rc.31622$1V3.770225',
  'R3v3r13!',
  'R3dbu11!?',
  'R1l3y08!',
  'Qwerty99!',
  'Qwerty11!',
  'Qwert123!',
  'Qw123456!',
  'Quazy45!',
  'QuYDE@y7u$ebE',
  'QuSA7E#ymYqanE',
  'Qu6Y5a5U#y6aqy',
  'Qq123!@#',
  'Qpalzm123!!',
  'Qnez8i_oN56!ZT9K',
  'QeMydYbY8y4U$u',
  'Qe4u#Etu#UQA2A',
  'Qballs1&2',
  'Qazxsw12#$',
  'Qazwsxedc12!',
  'Qerty12#$',
  'QM@en7@H',
  'QBBoomer789012!',
  'QAZwsx123!@#',
  'Q7cYa.4280$8n2.1876',
  'Pylon1234!',
  'Pumpsforless27!',
  'Pukk4P@d',
  'Pu9UTADAtU6e%U',
  'Ptwmam0!',
  'Psycle00!',
  'Pseema123$',
  'Proulx1328!',
  'PritiDe5@i283',
  'Prestige11!',
  'PressF1!',
  'Preech2$',
  'Predator3003!',
  'Pps86!!!',
  'Poxl1&zcmS',
  'Powder@123@',
  'Potogold2@',
  'Poseidon123$',
  'Porsche911$',
  'Porsche911!',
  'Porsche9!',
  'Poop888!',
  'Poker10!',
  'Poes0eke!',
  'Poenjap1$',
  'Pm2009@cs',
  'Pluton61!',
  'Plofster3?',
  'Player107#$',
  'Platnum1!',
  'Pitt1kater!',
  'Pisaka45@',
  'Pippilong9@#',
  'Pierce34!',
  'Phoolwati33#',
  'Phon3x6!',
  'Ph3@r123',
  'Ph0enix!',
  'Ph0en1x!',
  'Peter123!',
  'Perfect1!',
  'Penguins321!',
  'Pem3qud#',
  'Peluchin1986@',
  'Peetza1!',
  'Pearljam1!',
  'Peanutpoo3#',
  'Peanut1!',
  'Pd7kzu2rZ$eVRqNA',
  'Password73!!',
  'Password4me!',
  'Password1234!!',
  'Password123!!!',
  'Password11!',
  'Password1&',
  'Password02!',
  'Password01!',
  'Pass86word!',
  'Pass78word!',
  'Pass18@code',
  'Pass14word!',
  'Pass12word!',
  'Parker1!',
  'Paolo1983!',
  'Panther23#',
  'Pandemic95$',
  'Pan36dix?',
  'Pamela06!',
  'Pal2410!MirT007Dk',
  'Pablo5566!12',
  'Pa55word!',
  'Pa55w0rd!',
  'PSzt43##',
  'PSn!YaA0_#56E4bG',
  'POwder44!!',
  'PObox3229@@',
  'PNXOh.132437$_73.37019',
  'PIMpin1!',
  'PG_!jm5A89rXhL#7',
  'PEKub1@k1969',
  'PAmpAmpAM256YES!',
  'P@ssw0rd123$',
  'P@ssw0rd1!',
  'P@ssw0rd$',
  'P@ss3355!!',
  'P@$$w0rd!1',
  'P8!OFvGh526D#9_K',
  'P45SYaB3e_TAJ!#m',
  'P455c0d3!',
  'P0pc0rn30!',
  'OxJ5544!',
  'Ou8one#2',
  'Osiris99!',
  'OscarB2001!',
  'Orioles10!!',
  'Orang1364$',
  'Openup1$',
  'Op3r4nt!1t',
  'Omniasig1#',
  'Olivia12!',
  'Oliver1!',
  'Olemole11!',
  'Ohi0bel!',
  'Ogechi12!',
  'Oaffie57$',
  'O_2ZG9bkSinB5h!j',
  'OUcsN04$',
  'OQYc0w#4N91!iU6k',
  'OFeZa.51986$LD6.1136879',
  'O#k8n!IwpruT_93o',
  'O#f64_!Z1j9P7JL2',
  'NysaLee1!',
  'Nwe1lfie!',
  'Nutty55!!',
  'Numba1!b',
  'Nu8uzAQY!etuQU',
  'Nu5Ua5yvupu%Y',
  'None4u2!',
  'Nollan00!',
  'Nofearme2@',
  'Nmc81jho!',
  'Nits1204!',
  'Nips34!!',
  'Nikol26122011$mail',
  'Nikita1!',
  'Nigger24!',
  'Nigger09!',
  'NiesH1k!',
  'Nie6d9&h@nn88Gefffy',
  'Nicholas50!',
  'Nicholas1!',
  'NhzjBy4kEv$e',
  'Nhkg75d!',
  'Newport1#',
  'NewDay@50!',
  'Neta2200!',
  'Nervypooh57@',
  'NeqYge7A$YMYRA',
  'Nena0502!fb',
  'Ne5AtA!EHeXAzU',
  'Ne1469@618',
  'Ncm8j#2L10',
  'Nbdj3434!!',
  'Natal13!',
  'NaomiJune22@@',
  'Nancy123@',
  'NanavaJE6UGe#u',
  'Namourke1!',
  'Nala96B#',
  'NaPe8ELU8EtE!Y',
  'NOYnoy79$08',
  'NNat300911!',
  'NECROphage11!',
  'NC45qji8H!mZ',
  'N2kT!i0F1_zVLg9E',
  'N0r33n!!',
  'Mzr76!hj',
  'MyRex510!',
  'MyPpfAR2%3Apassword',
  'MyPpfAR2%3A',
  'My3sons!',
  'My3kidz2!',
  'My1&only',
  'Mustang06!',
  'Murdoch23!',
  'Mur@oc24!!',
  'Munster1!',
  'Munkeee3!',
  'Mufcsex6!',
  'MtHood2007!',
  'Mrr0b0t0!',
  'Mr5Exy$N',
  'Mpwerty1!',
  'Mozart69#',
  'Mopar93!',
  'Monkey0296!',
  'Molle976050???',
  'Mnstrdck7!',
  'MnQaB5$SdUv8p7yo',
  'MnPid6fhT!',
  'Mmore22@',
  'MmMt1984!',
  'Mm172@25',
  'Mk987@!w',
  'Mister2012!',
  'Minecraft56!',
  'Miles97!',
  'Mikerdude01!',
  'MikeMike1957@',
  'Microsek14!',
  'Microsek13!',
  'Michael1!',
  'Micaform1!',
  'Mi5rysrys!',
  'Mi11elac$',
  'MhK8ZBykT5s$',
  'Mh1@Ec2$',
  'MfqC5!6B04jRw',
  'Mf$9exyFtaC*SHUh',
  'Metalgear875$9988',
  'Mels4$$$',
  'Melodie1!',
  'Mellos12!',
  'Meikod2!!',
  'Meg143!!',
  'Meep02895!',
  'Me5U9e4UdUdY#e',
  'Mcn1if#jo',
  'MclarenF1$',
  'Mccrae1?',
  'Mc101al!!',
  'Mbp2006!',
  'Mazdarx6!',
  'Masterweb84917?',
  'Masterpapa55!@#',
  'Master123@',
  'Maryjo2@',
  'Marty20!',
  'Martin76$',
  'Marsb0y!',
  'Marmaa11!',
  'Marine1!',
  'Marina1961!!!',
  'MariaNorma321!',
  'Maria123$%^',
  'Maree69!',
  'March0500?',
  'Mantnio3@',
  'Mankon123@',
  'Mampu1983#',
  'Makitty01!',
  'Makenna1!',
  'Makar177!',
  'Majorca1!',
  'Majic12!',
  'Maikon123@',
  'Maiden08!!',
  'Mafia2014!',
  'Madison1!',
  'Madiga!517*',
  'Macho123!',
  'MUF7oQ9j2$t',
  'MThadtgo5a91$a&%',
  'MPre78@!@!',
  'MLcl342753#@*$',
  'MEeEP571!',
  'MDg7$*B9SRhb',
  'MD7Zi8!1fA03',
  'MAvu9uDe5a!ATA',
  'MAttg21!!',
  'MArines11!',
  'MAnoLi88#',
  'MA8egY2UReGY#u',
  'M@rk4$c$',
  'M@5ukp3@ch3z',
  'M3t4llic4$',
  'M3oT!16zwlQ#Pvg7',
  'M1nt1e33!com',
  'M1n3@l0ne',
  'M12R3k5!',
  'M1!mnx9rC6NdS#Lg',
  'M0T_dU4uIe18Y!#3',
  'Ly6yzAPu$AQU3u',
  'LwZQ8$F7',
  'Lw56D!dv40z#3c8H',
  'Lw23#@x59A',
  'LvA1tsd!',
  'Luxpoop8$',
  'Luvut0o@',
  'Lucky22!',
  'LsfIHpgw1G1stM$7',
  'LqV3mD$s',
  'LovelyJoJo82!!',
  'Loslos123#',
  'Lordik291281?',
  'Lor86&Kob89',
  'Longhorn6!',
  'LolzLolz1!',
  'Lola2008$',
  'Lola123!',
  'Lol47114!',
  'Lkot555!!',
  'Lima3243!',
  'Life333Live#!',
  'Lib00534$',
  'Li0nh3art!',
  'Lexie100!',
  'Letmein123!',
  'Letmein11!',
  'Letmein1!',
  'Letme1n!',
  'LetMeInPlease271#',
  'Lepa7y%a%umy4E',
  'Leeville1!',
  'Lee123!!',
  'Le53xpre$',
  'Le3Y#EzyGyHyRu',
  'Lcf#666#',
  'Lawera01!',
  'Lauren1$',
  'Lassie1!',
  'Lamand0$',
  'Ladybug79!',
  'Laala07?',
  'LaZAqEXu3y5U@E',
  'LYn12!@#',
  'LYiCvfgsZb8$',
  'LSr0Xbr0#!',
  'LOMOnosov1!',
  'LJF_Z#j7uw!xvXz1',
  'LHt2YaAVzM$n',
  'LADYgaga13@0',
  'L3tm3in!',
  'L1ghtH0u$3',
  'L0ngH0rn$',
  'Kzg73IO514!6',
  'Ky3srFVeZ@XY',
  'Kw1k$food',
  'Kvu1990$',
  'Ku98hgff!',
  'Kspz193@zeventby45',
  'Ks3d9oEnea$SqP4U',
  'Krypto96!',
  'Kruger03!',
  'Krist3n#',
  'Kris123!',
  'KrYp2@8*ToN',
  'Kp74045!',
  'Kosinus01?',
  'Korsymy7!',
  'KojinKdb9956!',
  'Koiwy11!',
  'Ko#Z!kQ65bn9ArO_',
  'Kniggknagg12!',
  'KisaMisan1!',
  'Kisa483!!!',
  'Kirill0666000Black&hite2BakaiK30',
  'Kinga123!',
  'KingKong123!',
  'Kill3rsm#',
  'Kholodnaya1!',
  'Kevin88!',
  'Kenton35$',
  'Kendall30!',
  'KellyB21$',
  'Keith00!',
  'Kd6XvfVwOXm%o7',
  'Katy1997!',
  'Kattekop2!',
  'Katlin101@',
  'Kasje01!',
  'Karma84?',
  'Kapi212!',
  'Kam1@sama',
  'Kalis11!',
  'Kaja@24!',
  'KaTTitA27!',
  'K_gp51Bw4vk#36s',
  'KYem22$$',
  'KJo3LsRc%VVUso5',
  'KJTAPx2@6R*espw',
  'KIiwbLajbd186$8a',
  'KAliegh24!',
  'K@r1shm@',
  'K@@PeNs8$XSTx9',
  'K3!vqcxS7HtN8_4a',
  'K!k1K!k1',
  'Juturna2@',
  'Jup1t3r!',
  'Juninho1999@2',
  'Juninho199927@27',
  'Junho2pm!',
  'Junedog3#',
  'July212007!',
  'July20Buddy!',
  'July0574!',
  'JuLEHygUnY6E$y',
  'Ju3Y#eJeGy#Yga',
  'Jty5LXbfnY2$',
  'JtYu78!@as',
  'JtL431DZUM!E',
  'Jst16ksH?!',
  'Jsma66##',
  'JrV!mF7Zd42N5qz_',
  'Journalism2!',
  'Joulukuu2013!',
  'Joshua20!',
  'Jordan23!',
  'Jordan1!',
  'Jop2jjn$kjasbj$',
  'John1321@',
  'Jn803959!@',
  'Jm567@@@',
  'Jkmuf28091986@',
  'Jiriki15!',
  'Jiohio*@&#@12@@',
  'Jg29586!',
  'Jg#Kb3UeN5In9_Z0',
  'Jeremiah2911!',
  'Jennifer1!',
  'Jennifer01!',
  'Jd622k7@',
  'JcjFd.399542$b5.19417614',
  'Java123$',
  'Jasc4321!',
  'Jamiejessie1$',
  'Jag13!133',
  'JaeJoong12!',
  'Jackson5!',
  'Jackfrost1!',
  'Jaanou1@#$',
  'Ja4A4yBY%a2ajU',
  'Ja19&Al05',
  'JYta2aQA$ErY2Y',
  'JOsie3246!',
  'JOanner@@79!',
  'JOPa70H!sdlu#82f',
  'JO!#ue28rtnA_XBb',
  'JEx4b.3072$L6.1012',
  'JDyteh94H75!0_GR',
  'JBfeb90!@',
  'JAtuGa5EPu!ysu',
  'J@poN16?',
  'J5Bkvrx6$LweZfXt',
  'J0vV81?R',
  'IzP8^UchD$Swh6',
  'Iwbon20071986?',
  'IwJLH0!9',
  'Iv@n@B0j@n@',
  'Itsme123!',
  'IrocKtehm!n3z!',
  'IriverIHP140!',
  'Iren1982#',
  'IrIsHa250$K',
  'Ipdsmjrl16!',
  'Ioua69!!',
  'Ion2008!',
  'Io5#Lvq6',
  'Infinity0!',
  'Indians7!6',
  'IndiaGate12#',
  'India123$',
  'Incognito101!',
  'IloveFD2@',
  'Il0vefrance!',
  'Igot1Billion$!',
  'IgUsG65r$',
  'Idm#U3ktqM_r1!H5',
  'Icecream5!',
  'IanSan93$',
  'Iamaboss1!',
  'IO_X!0xM485P#okK',
  'II#b56paSS$$',
  'IHateSn00p$',
  'IG9p0YtN5_!4j1#r',
  'I8f5xYz$qL5ax@k',
  'I65he10!',
  'I1asti9thg!!!',
  'I0c0ky!e',
  'I#l3F98PJbjmEx_',
  'Hy8yRe!yMY9yda',
  'Hy72g&&92nj',
  'Hx7hh&0C!stK',
  'Huskers1!',
  'Hunter1!',
  'Hulk100$',
  'Hu6y9ABU6uSU%u',
  'Hpsauce321?',
  'Houston713!',
  'Houston1$',
  'Hous77002!',
  'Hotdog2013!',
  'Hookberry25!',
  'Honey62657404!!!',
  'Hollist33r!',
  'Ho8i%p&tty45Dp',
  'HnsJKQmM6$Tb',
  'Hl2hookcss!',
  'Hjptnrf78!',
  'Hitachi11?',
  'Hireme2013$',
  'Hir0*Masi!',
  'Hipeople1!',
  'Him1123$',
  'Highnoon1952!!',
  'HiMym1777#',
  'Hgu*QZR4jP7Q7#&',
  'Hgf1234p!',
  'Hershey925!',
  'Hello39!',
  'Hedin83@',
  'Hd6#2J18bnlTvf5M',
  'HbtxP6lNy!',
  'Harr3m@rk',
  'Hari12@hara',
  'Happygorila123@',
  'Happy123$',
  'Hannahm123?',
  'Hamburg1!',
  'Hafrust11!',
  'Hades20!@#',
  'Hacker1234@',
  'HackSlash4751!!',
  'HwiM170126!!!',
  'HQ894vj!uzG7_nBy',
  'HAlo117!!!',
  'H4ck3rs!',
  'H328Mv1v$$I',
  'H1r@m10$',
  'H1lx#d_BM2tJ!h5X',
  'H0vE6_N8#oVGB!k2',
  'H0r4t10!',
  'H.p.patel$14$2010',
  'H.p.patel$14$1956',
  'H!aY65l_C8xA',
  'Gy7U%yBAbaRuRa',
  'Gwend0!en',
  'Gulch%26#33;',
  'Guido12!',
  'Gu6y!Y5E4YbABu',
  'Gtnh0uh@l',
  'Gregory28!',
  'Greek25metro!!2',
  'Grapes1!',
  'Gr8ful14!',
  'Gooseman17!',
  'Goose88!',
  'Goldust1!',
  'GoforitNow7!',
  'Godsson12!',
  'Godisgreat123$',
  'Gobolts91!',
  'Gntyxbrz1?',
  'Gntesa8E!',
  'Gk!anBn7f9#',
  'Gj9cg6qz$nrU',
  'Givori123$',
  'Ginger12Satyam@#$',
  'Ghjcnj12345@bCntgf',
  'Ghjcnj1!',
  'Gh10502!',
  'Gg&7Kk!1',
  'Gfieylbq08!',
  'Gf64wz$%',
  'Gettingitin123@',
  'Georgia01!',
  'Gemini1983!',
  'Ge3a8UZy#A6EZE',
  'Gates123!',
  'Gal4onok!',
  'Gabiroba99@',
  'GaN1*damo!',
  'Ga7uvy#AJUnapu',
  'Ga7Y3EBeLy%adu',
  'GYNYge7A@a$AQE',
  'GV!3N8#Upm62T_Bb',
  'GOose119#!',
  'GOnavy55$$',
  'GOdawgs10!',
  'GObig2010$',
  'GOarmy567$$',
  'GOarmy42$$',
  'GO.army.85!',
  'GLor1956$$',
  'GLock45!',
  'GIb3397!',
  'GEgu5ypE@Eqyne',
  'GAna19845!',
  'GAbaGUtu5E!eSY',
  'G169EfM$4$4rw',
  'G0tm1lk?',
  'G0tM1lk?',
  'G0tM1lk!',
  'G0tB33r?',
  'G0d3v!ls',
  'G02t0wn$',
  'G00d2g0!',
  'G00d$0C!',
  'G#8Ep1OnU30!5764',
  'Future5&',
  'Future2$',
  'Fusion4$',
  'FurryFab4!',
  'Funnymoney2!',
  'Fug10abc!',
  'Fuckyou1234!',
  'Fuckyou1!',
  'Fuckyou01!',
  'Fuckthis1!',
  'FuckTh4t0ne1!',
  'Fruit.1!',
  'Frostie07!',
  'Froggies1121!',
  'Frodoa112!',
  'Fritz24!',
  'Friskey7711$',
  'Fridge1!',
  'Frida2009$',
  'Fric2012!',
  'Freweini1!',
  'Fresno1972!',
  'Frenchie12!',
  'Freedom3!',
  'Freed0m$',
  'Freed0m!',
  'Fredmax9!',
  'Frederika1#',
  'Freddy1000!',
  'Freddie1##',
  'Fred22!!',
  'Frank347!',
  'Francois191193!',
  'Francis27?',
  'Fragglarna23!',
  'Fr4nk13!',
  'Fr3d1ee!',
  'FoxyGirl43!!',
  'Foxdoc21!',
  'Fox2004!',
  'Fortyniner1!',
  'Formula51!',
  'Forests09!',
  'Forestdog1!!!',
  'Ford6942CO!',
  'Football1!',
  'Food123!',
  'Fokkerdr1?',
  'Fofie79?',
  'FoKS16!@',
  'Flyfish2022!',
  'Flyboy6&',
  'Fly&37#now@#',
  'Flower1!',
  'Florin115!',
  'Florida1#',
  'Flore03!',
  'Flock1@#',
  'FlfprCNg0kB1e!ai',
  'Fleur312!',
  'FlM2010!',
  'Fl1ntst0ne!',
  'Fl0und3r!',
  'Fl0ater!',
  'Fkmaf123!',
  'Fishybook1!',
  'Fishslap1!',
  'Firebird1@',
  'Fingbastard9!',
  'Finchman92!',
  'Figero123!',
  'Figaro81#',
  'Fifa2006!',
  'Fidele13!',
  'Fhhh721D__!#',
  'FhN946*r!',
  'Ff1F1QZyaa!',
  'Fernando123!',
  'Fern1428!',
  'Fermat09?',
  'Ferdinand1987!',
  'Fenrir84!',
  'Fella16?',
  'Feendi0s!',
  'Federated1!',
  'Fearnaught1!',
  'Feabea51!',
  'Fcvjkej5$3rgwsd',
  'Fb4tmof!',
  'Fanjul12!!',
  'Fam50Z8e_6T#Yiz7',
  'Falcon86!',
  'FalJh.3790$JZ3.1568',
  'Faith1988!',
  'Fade420!',
  'Facn8tn$',
  'Fab6535@Gemin',
  'F_59G6vzB7HxcC4#',
  'FVXywA3tkzECiv$Z',
  'FSg154?h5544',
  'FREEdom66!*',
  'FEMAboy1!',
  'FArcrY88@',
  'F7J2b.41828$0u4.21814',
  'F3rr3tfac#',
  'F3906c7!',
  'F22e2b1!',
  'F1Xm3!Pl3@s3',
  'F11a2b8!',
  'F0b2a23!',
  'F!ref1i3$',
  'EzhUh.269$Yo2.129',
  'Eyecandy159!',
  'Explore2011!',
  'Exmouth07!',
  'EwyaP0$zs',
  'Evringham1!',
  'Everton10!',
  'Evenareny3#',
  'EvAGeve4a$AZu',
  'Ev3rgr33n!',
  'Eustolio2008!',
  'Eus0m@toder',
  'Euro500$',
  'Eurasia4!',
  'Eurasia12!',
  'Ethan1925!',
  'Estrada1!',
  'Est3r@018',
  'Esquimalt08!',
  'Erika03$!',
  'Ericowen2!',
  'Ereehna2!',
  'Epsilon12!',
  'Ep244789!',
  'Enu5$kHrZqx2',
  'Entheos1010!',
  'Ent3rt@inment17',
  'Enl2013!',
  'Enkidu2275#',
  'EnigmaB2010!',
  'Englischmichaelo7#',
  'Enforcer66!',
  'Endurance1!',
  'Enc1rcL3$',
  'EnU4ESUgudU#yS',
  'Emmett0726$',
  'Emmagail1!',
  'Emma1997!',
  'Emma1281!',
  'Emkasec22@',
  'Emin3ma$',
  'Emily010101!',
  'Emilil7!',
  'Emilia88!',
  'Emdbaj7q!',
  'EmanYBe8a4ANU#',
  'EmHump32!!',
  'Em1nem$cd',
  'Elyssa09!',
  'Elyomar12?',
  'Elsuen1o#',
  'Elpicsid1!',
  'Elkm2008!',
  'Elisha181!',
  'Elephant1978$',
  'Election10!',
  'Elbruz735!',
  'ElPalacio11!',
  'ElCid74!',
  'El1z@eth',
  'Ekimx15!',
  'Ekimcoco1!',
  'Ekaterina5!',
  'EjEBUqy6Y$yHYp',
  'Eindhoven4409!',
  'Ein5tein!',
  'Eight2011!',
  'Eiferd1#',
  'Ehy7ubU6y9aJA$',
  'EhAje2e#umALAG',
  'Eh32590!',
  'Egrebal1#',
  'EenjoyY87!!',
  'Edy2AmA2yY$eP',
  'Edwin1911!',
  'Edmac4L!',
  'Edidem3008?',
  'EdA2Y$UpETy5aH',
  'Ed8qzt98!',
  'Economics101!',
  'Economics1!',
  'Echo8Bravo!',
  'Eatshit2k!0',
  'Easypay010!',
  'Earth365!',
  'Eai2@V$D%yh#',
  'Eagles5!',
  'Eagles1586!',
  'Eagle88!',
  'Eagle223!',
  'EZ0_6skepOi4#LK!',
  'EXYge9E$ynuRa4',
  'EebeDU3e#eRA',
  'EVySU3y9y$ysY6',
  'EV5r0va$1',
  'ES_zc.6353$Ln4.302',
  'ERAmE4U@ASeLe8',
  'EQu2YMu5a#AhEm',
  'EPw00k!i33',
  'EPt8q2rs!',
  'ELamor16?',
  'EGabu7evUtA@AR',
  'E72e105!',
  'E6_d7!j0Iy#s92gS',
  'E3E5u9ujuZESA@',
  'E2d9y3s0o0n1o!M',
  'E29de1b!',
  'E13B17eclipseJ13R17#',
  'E05c326!',
  'E041f4f!',
  'E%70%69%6c%6f%74_c',
  'E$u#Y2UjaDe2a%',
  'E!e8yNA3ydyzy#',
  'Dylan0605!',
  'DxqRc6mfuQ0!',
  'Dwilla123!',
  'Dvtdtif4$',
  'DuuaQqv2e??',
  'Dustin12!',
  'Dupont12!',
  'Dupage1#',
  'Dunlop58?',
  'Dunekant6644?',
  'Dune$!7?',
  'Duke1983!',
  'Duflickenkoft1!',
  'Dudley3!',
  'Ducktape2#',
  'DuchesS2!',
  'Ducadoggy1!',
  'DuMB0083!',
  'DsQHKv@%3z@0',
  'Drzej69!',
  'Dryden1!',
  'Drose1!$',
  'Drmario500!',
  'Dreemz1!',
  'Dreamer2!',
  'Dre@myCh0c0l@te',
  'Drazenka1&',
  'Draper7!',
  'Dragons86!',
  'Dragon9!',
  'Dragon25!',
  'Dragon1!',
  'Draeger7&',
  'Dr4a$gon',
  'Dr112211!',
  'Dpo8TNLj7@h',
  'Dominique001&',
  'Doink81x?',
  'Doinit22!',
  'DoingGr8!',
  'Dmitov7$',
  'Dluv7@M18u',
  'Dltttf1!',
  'Disturbed98$',
  'Dimwit14#',
  'Dimoos1997@',
  'Dimension0!',
  'Dima22866!',
  'Dima123!',
  'DietPepsi15!!',
  'Dgl3ep1R79!!',
  'DgOn$gG%3&',
  'Dfd9f60!',
  'Df1!duck',
  'Deuce24!',
  'Detroit1020!',
  'Detroit1!',
  'Desmond7216!',
  'Derv15h!',
  'Den!$!98!1981',
  'Demon07!',
  'Demolition1!',
  'Dem0killer!cc',
  'Dela@61#',
  'Deema86!',
  'December11!',
  'Dec2009!',
  'Deb!620!Kline',
  'Deathnote0!',
  'De!b2de!',
  'Dd03251998@',
  'Dckt254!',
  'Dbrnjhbz55!',
  'Dbd6663!',
  'Daysia17?',
  'Davies79!',
  'David40!',
  'DarkKnight69!@',
  'Daphne0278!',
  'Daisy330@',
  'DaRqUe!2#',
  'Da1$yMay',
  'D_0GiM#754!AEjq2',
  'DUbU@AvA5e8U#y',
  'DUBlin69$',
  'DU4u6ugu$EHa8U',
  'DR5J8ZoS_3!kT29',
  'DR4h8zSn$b6m',
  'DPXOh.132438$_73.11810',
  'DOOkie19761!',
  'DImples85$$',
  'DIMITRIk2k@',
  'DGjg0724@%',
  'DEDeDEgA4a$u8E',
  'DEATHd51!',
  'DAJU!y7e#uXyge',
  'D5h%9o7*',
  'D4TXkyLb3m$pV8Zw',
  'D3fi3633#',
  'D3@th3@t3r',
  'D2_Rvz6C!Yua540j',
  'D1ct10nary!',
  'D15a3d8!',
  'D0nuts7777!',
  'D0nt-P4n1c!',
  'D0m1n010!',
  'D!sC0V3r#',
  'CzANOvp2h41Yu#wo',
  'CyberIntel1!',
  'CyCl0nz!',
  'Cy3459cy!',
  'CvuRb27!',
  'Cuttyhunk%C2%AE',
  'Cur1bst!',
  'Culv6914$',
  'Cujo4392!',
  'Ctb629?1',
  'Cspc113!',
  'Cs92und@1',
  'Cs08Cs08!',
  'Crypton99!',
  'Crosslink0!',
  'Crossing11!',
  'Croatia1!',
  'Cro80597450@',
  'Cristian77$',
  'Cris1Alex!',
  'Craolyn1?',
  'Crabgrass1!',
  'Cr8@27ran',
  'Cr8@20dec',
  'Cr8@01vij',
  'Cr8@01dec',
  'Cr3@t3@201',
  'CqjUfy183$2',
  'Cp9O_Gqr15Rj!s#x',
  'CowboyS2009!!',
  'Cotulla2010!',
  'Cosmos0!',
  'Cosmo123!',
  'Cort619!',
  'Corsair146!',
  'Corinne04!',
  'Corey0625!',
  'Copperfloor79!',
  'Copixo11&nbsp',
  'Cooper01!',
  'Coolk1w1!',
  'Cookies1!',
  'Consulting01!',
  'Conoco123!',
  'Connor12!',
  'Conner12!',
  'Conan86#',
  'Computer1?',
  'Compassion47!',
  'Compaq1@',
  'Commie555!',
  'Commando2006!',
  'Commando162!',
  'Colusaf1#',
  'Colonel1#%*',
  'Colin10!',
  'Coke1234!',
  'Cohiba01!',
  'Coconut13!',
  'Coco19561!$',
  'Coco1234!',
  'Cobbps1@',
  'Cmx1811!!',
  'Cmok2005!',
  'Clyde29?',
  'Clm8000!!',
  'Clinton2!',
  'Clinton1!',
  'Cleveland7!',
  'Cle14nav!',
  'Clck1015!',
  'Claudiu2009!!',
  'Class10!',
  'Claire2001!',
  'Clackamas2!',
  'Citico48!',
  'Citadel45!1',
  'Cirque1!',
  'Cinnamon1$',
  'Cinet5500!',
  'Cia4life$$21!',
  'Chuys01!',
  'Churchill1!',
  'Christob1!',
  'Christian12!',
  'Chornyvolk1!',
  'Chopper15#',
  'Choda1972!',
  'Chocolate69!',
  'Chitara83!',
  'Chinahand1943!',
  'Chimaera61!',
  'Chill123#',
  'Childf0rm$1',
  'Chicago1!',
  'Chester1?',
  'Cherry2@',
  'Chema1963?',
  'Chelsea15?',
  'Cheller62!',
  'Chehali1%5D',
  'Chaucer1!',
  'Chasedog01#',
  'Charliex1!',
  'Charlie59!',
  'Charlie1?',
  'Charlesftw007!',
  'Char10tte!',
  'Chaindog1!',
  'Chaim613!',
  'Ch9#Z!l_i0862uUM',
  'Ch3y3nn303!',
  'Ch3659!!',
  'Ch1c@g0Cubs',
  'Ch0keme@3',
  'Ch0ked0ut!',
  'Ch0C0late423$',
  'Cg_56MRT!u2n',
  'Cg_56MRT!u2',
  'Cft6yhn!',
  'Cfcxc.7031$Ih.653',
  'Cement6&*',
  'Celtoid2!',
  'Celeste3!',
  'Cegth10$',
  'Ceeb35c!',
  'Ce7#&OO$aA',
  'Cde3$esz',
  'Ccarly11!',
  'Cc57019!',
  'Catspupil3!',
  'Cathy12#',
  'Catfood335!',
  'Cataparola1!',
  'Casper00!',
  'Casino4ever!',
  'Cascades2014!',
  'Carter1!',
  'Carrots01!',
  'Carolina1!',
  'Carnival1#',
  'Carmen1#',
  'Carmen1!',
  'Carmelo15!',
  'Carlson13!',
  'Car4uDurga!@#$',
  'Cap19619?',
  'Candy1225$',
  'Cand1es!',
  'Cancelar980!',
  'Canadapu1!',
  'Canad1an$',
  'Cameroon123#',
  'Cam75098!',
  'Calvin97?',
  'Calvin2!',
  'Calvin1325!',
  'Calvin100!',
  'Calgary01!',
  'Calcio86!',
  'Cadence2233623!',
  'Cadence1!',
  'Cabelas9!',
  'Caba1ler!',
  'COMICag27!',
  'CNLqyiPV4$xm',
  'CJ98wk4v$RD',
  'CHicks43!',
  'CHester27!!',
  'CFsecurity3!',
  'CBw0o0$#Pr9',
  'CBarker88!',
  'C@Nt0_17',
  'C9I1e876@',
  'C8e1266!',
  'C85de32!',
  'C630a04!',
  'C5a1p89$',
  'C2v6t5P#',
  'C2p786n#',
  'C2a3r31568!',
  'C265f02!',
  'C20h25n3O!',
  'C1n3D!*70C',
  'C11ef59!',
  'C0mp0$e2k',
  'C0mmander114!',
  'C0cy1n4!',
  'C00lhandluk3!',
  'Byyerty14!',
  'By*p2a1$',
  'BwTmRS6C#',
  'Bw801gut!',
  'Bw2ms$4L',
  'Buzzard0!',
  'Buy1more!',
  'ButtR12@!',
  'BusterNokia58!!',
  'Buster99!',
  'Busted61#',
  'Busted3825!',
  'Busdriv3r!',
  'Burrito10!',
  'Burnley35!',
  'Bunga12#',
  'Bullshit1!',
  'Bullet002!',
  'Bullen1$',
  'Bull1972!',
  'Bulgaria1!',
  'Buildaman4u@34',
  'Bugsy854!',
  'Bugab01!',
  'Buffy12#',
  'Buffalo6125!!',
  'Buffalo1!',
  'Buddy12#$',
  'Buddy01@',
  'Buddha610&&',
  'Bu2MiL88!',
  'Bu11D0g$',
  'Bu1!@t0r',
  'Btb11169!',
  'Bsffl6jb!',
  'Brutz0r!',
  'Brutus11!',
  'Brunssum28!',
  'Bruce13H!',
  'Brp4bja!!',
  'Browns90!',
  'Brown100!',
  'Broram1!',
  'Bronx1954!',
  'Bronco10!',
  'Bromeliad6!',
  'Brinker11!',
  'Brighton86!',
  'BriennA03!',
  'Bridget1!',
  'Brianna96!!',
  'Brett09!',
  'Brett04!',
  'Brendan1s!',
  'Breck105!',
  'Breban23#',
  'Brat2728!',
  'Brasil3230!',
  'Brannon1!',
  'Brandy81#',
  'Brady09!',
  'Br3@th!t',
  'Br00klyn!',
  'Br00k$P@$$',
  'Bpl09426#',
  'Bowlers12#',
  'Bosco1@hom',
  'Bos3n536!',
  'Boring5!',
  'Bordeaux52!',
  'Borazeile14!',
  'Boomer95!',
  'Boomer1!',
  'Books123!',
  'Book0070!',
  'Bonnie65!',
  'Bonnie1!',
  'Bong2664$',
  'Bonefish1!',
  'Bonds1A$',
  'Bond007!',
  'Bodo723#',
  'Bodhi2512!',
  'Boat2628##',
  'Bntc2009!',
  'Bluemoon123!',
  'BlueBerry00!!',
  'Blue9191!',
  'Blue2583!',
  'Blue2508#',
  'Blue1414!',
  'Blizzard1!',
  'Blinky12#',
  'Blindmatter5!',
  'Blessed30!!',
  'Ble@ch13$C',
  'Blazer9!',
  'Blazer12!',
  'Blargle18!',
  'Blahblah1!',
  'Blah2Blah!!',
  'Blacky1!',
  'Blacks55!',
  'Blackjack7#',
  'Blackjack1500!!',
  'Black12?',
  'Blablabla1!',
  'Blabla11!',
  'Bl2pbb!10',
  'Bktk6163$',
  'Bkahuna2!',
  'Bk643w!_g520#dYc',
  'Biziness1!',
  'Bizango00!',
  'Bismark33!',
  'Bishkek2010!',
  'Bisbee10!',
  'Birdieman53#',
  'Biodtl52!',
  'Bio20!!!',
  'Binney64#',
  'Binger72!',
  'Binata8r!',
  'Binapragati1@',
  'BillyBob707!!',
  'Bill8it!',
  'Bill7154$',
  'Bill466!',
  'Bill1234!',
  'Bighouse1!',
  'Biggirl2!',
  'Biggie567!',
  'Bigfoot1!',
  'Bigdog13!',
  'BigRed187!',
  'BigApple1960!',
  'Bidoeira63!',
  'Biblio1!',
  'Bhaskar8#',
  'Bghru4*8$',
  'Bfdt9w6G!',
  'Betsy12#',
  'Beth1024!',
  'Beta0619$',
  'Bestia1?',
  'Besson1!',
  'Bernoulli01!',
  'Beren1986!',
  'Benfica1?',
  'BenZac1!',
  'Ben4$hog',
  'Belmont4831!',
  'Bella123##',
  'Belizean1!',
  'Believ3r!',
  'Belgium22$',
  'Belarus1#',
  'Belarus06!',
  'Beg1nner!',
  'Beefyboy1!',
  'BeeBe4u211!!',
  'Bee1c@ve',
  'Beaver57&',
  'Beauty4me@4704',
  'Beau1275!',
  'Bear4243!',
  'Bear2327#',
  'Bb4j200$',
  'Bb3182!!',
  'Bb15ae3!',
  'Baythorn1!',
  'Baxter2307&',
  'Bax7006768!',
  'Bassgod1!',
  'Basscube1!1',
  'Bass4life!',
  'Baseball77!',
  'Baseball13!',
  'Barney1!',
  'BarnYard63!',
  'Barn1ey!',
  'Barclays1!',
  'Barakz1!',
  'Bapu007123@jagya',
  'Bans0ter!',
  'Bangkok1!',
  'Bandit60!',
  'Bandersnatch2!!',
  'Bambam24?',
  'Balto2010!',
  'Balrog01!',
  'Ballet87!',
  'Balita1!',
  'BakuT0m!',
  'Baker123$',
  'Baka12$x',
  'Bahrain1!',
  'Baghdad04$$',
  'Bagels2k15$',
  'Badfuck1!',
  'Backspace12!',
  'Bace04!9',
  'Bac01c8!',
  'Babylon_5!',
  'BabyLili1!',
  'Ba53Ba!!girl',
  'BXNbMnavYT!0=Om4',
  'BX25e.10785$FN4.3762',
  'Bsw$$76@@',
  'BVaI8TX0O1h24#xf',
  'BRiaNNa11!!',
  'BPVC2xK9Fw$s',
  'BLSfD!_5u4#bmaV8',
  'BKt5P$UEyaLbk6R7',
  'BInewengland11!!',
  'BEmE3A#YnytY$E',
  'BENyU5yzaRy#E',
  'BELLmont82$',
  'BC69b.127$Ix3.20738171',
  'B@Tsh1tCR@ZY',
  'B6x5i7ksV#',
  'B3n@0rk%',
  'B0Hne85!',
  'B00kR3@der',
  'B!u3!M@t',
  'Azy8a#YhytySYM',
  'Azsx1234$',
  'Aza9y3udYhy!U!',
  'AzU3EVumUMU%Un',
  'Aycksl23&%fjaoedz',
  'AwesomE@1313@',
  'Auyn2007!',
  'Autumn11@',
  'Aut?bot1!',
  'Aunib123#',
  'Atscva1!',
  'Atomic808!',
  'Astr0not!',
  'Assumpta01!',
  'Assi654@gu',
  'Asonny1#',
  'Ashley00!',
  'Asdfghjkl90!',
  'Asda123!',
  'AsY$U9yTa%AdaP',
  'Arvamus7!',
  'Artistry87r@ptor',
  'Arthurian5K?',
  'Arradan1$',
  'Arnold9!',
  'Armada23$',
  'Arkon74!',
  'Aris5555!',
  'Arich258@',
  'Argentina100!',
  'Ardisj25!',
  'Arcymag1!',
  'Arches33!',
  'Arav1nd!',
  'Ar239383!',
  'AqU3E$UQATY#Ez',
  'April162001!',
  'April15#',
  'Apr2010!',
  'Appr0v@lDB',
  'Apples1!',
  'Apparent5#',
  'Apollo2828!',
  'Apollo01!',
  'ApE3YXe#a9uDe@',
  'Ap0c4!yps3',
  'Anushka21!',
  'Anubis1980!',
  'Anu1963pam!',
  'Antoniachocolate123@',
  'Anton23!',
  'Antec80$',
  'Ant0nnAnt0nn#',
  'Ansgar05!',
  'Annie98!',
  'Annie4147!',
  'Annettep1!',
  'Annemartha1!',
  'Anne864!',
  'Anjocc17!',
  'Angels09!',
  'Angelita1?',
  'Angela88!',
  'Angel70!',
  'Angel1107!',
  'Andrew99!',
  'Andreas47!',
  'Andrea13!',
  'Andre29!',
  'An01Ch11Ma26Pa05@',
  'Amyski11!',
  'Amraam120!',
  'Amraam0187!',
  'Amosss1213!',
  'Amfirst123$',
  'Amexhts1!',
  'American1!',
  'Amberleigh05!',
  'AmberLeaf123$',
  'Amber17!',
  'Amber12!',
  'Amanda15!',
  'AmPZv$2f*Lh',
  'Am8ulance!77',
  'Alvin103$d',
  'Alvin1#$',
  'Alphadog117!',
  'AlphA21#$',
  'Alph@t3t@2',
  'Allways1!',
  'Allie50!',
  'Allergy1!',
  'All4the$',
  'Alice88Hoshi!',
  'Algernon1!',
  'Alfa4016#',
  'Alexg1984!',
  'Alexandra3#',
  'Alexander1!',
  'Alex1985!',
  'Alena29$',
  'Aleforce1!',
  'Alecash1$',
  'Alec007$',
  'Aldershot01$',
  'Alcatraz01!',
  'Albat1rose?',
  'Alaska13!',
  'Al1k!Lena',
  'Aktis321!',
  'Aks112778#',
  'Akasaka5!',
  'Ajaj11??',
  'AitD4me!',
  'Airmax1!!',
  'Airforce47$',
  'AirForce08!',
  'AirBorne99!!',
  'Aida82!!',
  'AgyRe8E#unydy9',
  'Aggies52!',
  'AgavugA7yseMY#',
  'Africa123!',
  'Africa1!',
  'Afiliti106!',
  'Afghan1!',
  'Afc8e6d!',
  'AfROKOs0$EhiF^2xU0HH',
  'Aesculapius9!',
  'Aes0222!',
  'Aerobics13!',
  'Aerc2004!',
  'Adventure23!',
  'Adrian66?',
  'Adlae2005!',
  'AdUBEa2a%U8aX',
  'AdESyjU2AHe%ag',
  'Achilles1!',
  'Ace2013!',
  'Ace1cAt!',
  'Accts2004!',
  'Aca359b!',
  'Ac22dfb!',
  'AbyVc45m!',
  'Abreed1956#',
  'Abraxas1!',
  'Abraham1987$',
  'Abkfhvjybz70!',
  'Abigail2004!',
  'Abcd123$',
  'Abc123##',
  'Abc123!@#',
  'Abc123!!!',
  'Abby2007!',
  'Ab972504?',
  'Aaron123!',
  'Aa8675309!',
  'Aa24681012!',
  'Aa123456!',
  'Aa1225441!',
  'AZaVEgY7U@eZAd',
  'AXUdA6e#ARUQuV',
  'AuNESUpu9u!AS',
  'AV9HQm!_Iujv4dG#',
  'AUGust21!!',
  'ATyVydUse7U$yT',
  'AShp3*7$wMU4',
  'ASev24091981!',
  'ASa%uhA4yMY#a7',
  'ASDFasdf1!',
  'ARko669!',
  'APuQu4E!u$egE8',
  'APl@ceF0rP@rks07',
  'APeLY4U%Y#A@YL',
  'APJPmar2014!',
  'AMewV89651!G',
  'ALberico1!',
  'ALLAsaktaANAMDY180859!AIMAN',
  'AKrbrM587543?-',
  'AIrplanesfly12!@',
  'AIrborne11!!',
  'AGe2UmUgA$y2yV',
  'AG18yeH0tB4o3!59',
  'AFmatt13$!',
  'ADy7Ume$egYLu',
  'ADam256!',
  'AAreyes65#!',
  'A@U$u9umE$y!AB',
  'A9eXA6u6U2Aha#',
  'A9ae4d7!',
  'A8u7g55!',
  'A8UqU6a#u8UgES',
  'A7m8i6t@9',
  'A6E7A4y9E$aNEn',
  'A5!kx_Nb7m#My4J9',
  'A1s2d3f$',
  'A1r2m3y4!',
  'A%Z*H!adidas2012^',
  'A#e5YzEge$yrAz',
  'A#aVa6e@E7uDA#',
  'A#DhBe_N4!ty2YIg',
  '@rY4Rk5!',
  '@YsaMA7UJA!UnU',
  '@YVe9uZegYVa#a',
  '@T3mpP4$$w0rd~',
  '@G0CalB3@rs$',
  '@Fja132701@',
  '@B1a2b3a4i5k6o7@',
  '@ATeRYDu3eDa$A',
  '@7Nosaj6@',
  '@!Landcruiser98@',
  '=Yh3z#8!C27sbZ4i',
  '9pR7b.34164$875.1428271',
  '9j2S#Qfmy461h!0H',
  '9esegEXa8A%Uy',
  '9eraduSuLU2a$a',
  '9UMEPy5E#UQuZA',
  '9T4m36P_JF7!B2VZ',
  '9I2s7j48oeUviy1#',
  '9Hse8xSyg@hr',
  '9Hse8xSyg@hR',
  '9E66bc4!',
  '9D_687SAzG4J!#I2',
  '9D7fd91!',
  '9B4kNn8M5s!!',
  '99Fc16f!',
  '92dZjO6S!R_r',
  '9!6Rs84zS1_0pTO3',
  '8tPNa.150919$lK4.4232266',
  '8i_7P#nh5!1EmozZ',
  '8U2A8Y@yzY6e$Y',
  '8T9m2f33!',
  '8LVn#K72aZ!SUl_',
  '8EjU8EPE$yDa3A',
  '86Alexe23#',
  '83@Rm0ZZ!3',
  '7uFskju89@vq4888Mnvd',
  '7_rQTS305zq2#9nV',
  '7UqNp*6$vrFBR8o2',
  '7R_zc.6351$fq4.3490',
  '7J_4wDSl39x6O#UB',
  '7EJAi05!aSlo#_3d',
  '75HBUvKy6sX3FjN!',
  '73r#nQd2!fSa48t0',
  '73Frogs4u&',
  '73@Asya91_54',
  '72Dal85!',
  '70OZ8l6#x4FEmnP',
  '706Ff7a!',
  '6w#3!0efDQRGx8z_',
  '6fD2Axc4zbH#5o8T',
  '6UPy8E!U5abeY',
  '6Sx&72!j&mM',
  '6S2b7!FIDu_#4Yx',
  '6Pc1rV#XEM!SdKJ7',
  '6J1BsRr4G!5nz02K',
  '6Ecbd5d!',
  '6E987b4!',
  '67_MndUju0!x1YQ',
  '6451QcG=Pb32FUr#',
  '62490Pippin62!',
  '61Ee116!',
  '6!2JvScbR#95N_g',
  '5pYr0cYnd3r!',
  '5kiRzJc8NUw!_LQs',
  '5h18jPoGfnY7#!_0',
  '5ePAdaGA7e#eLu',
  '5b03!Fn1_U#gqH6L',
  '5YmAMeu6YbU@a',
  '5#Tw3!oMFcB4yN9',
  '5TcKk802B6piH4L#',
  '5May2010!',
  '5KYoSc1k97$bV04',
  '5K2ti9Tmg6Uu#!CE',
  '5E6b041!',
  '58uw!x4B2Drq1d#s',
  '58Fe9d1!',
  '53MiNuS53@0',
  '51m_4vPRz96OZ!uU',
  '51!mt_9PzXbRI4s#',
  '5#9E!eM60IXvPs_j',
  '5#8RjFh2!_b7wxld',
  '4ymYbE9ugy$eXE',
  '4g58#96L0N7o3_DA',
  '4e6uQyze9u!eZE',
  '4doGb0ne!',
  '4cvjJHEn86#!0275',
  '4_in2xuNOk1tH#0B',
  '4_hS9aD5KNLkJs3#',
  '4ScoreN7!',
  '4Research2?!',
  '4Lovver2!!',
  '4GsltwJ3!6',
  '4Ec9988!',
  '4DRhS8qz$me',
  '4DHVK6pS!5X#n1_c',
  '4D9c229!',
  '4D237e3!',
  '4AHu4E@uJaJA9Y',
  '48Ta2Px$eHX',
  '47z#Euh6Jk_x9!fF',
  '46Af75b!',
  '44Dj8fP%',
  '42E_0ks8!NALmhd#',
  '40g1Of14H4T#Sd',
  '3y2oEA_DcRP9s6T#',
  '3hEjb.355006$Lnr1.130281',
  '3dwMk9r$',
  '3cLsD1P5!pI_zjk#',
  '3PBx#036;hdy92Ye',
  '3EuMOT9sJd@cswttG^0',
  '3BMchtr2!!',
  '38Rzb.438$v64.241',
  '36KrwscT1030?',
  '34P7Lhr9#sxLTq47',
  '308Cc29!',
  '3#9evf_M1Hw0!5c',
  '3!I2f7BO9bxlAU_Q',
  '2qAwV!#S5Pe8_gs',
  '2dwMk9r$',
  '2Y40uC5!Q1KAP',
  '2Pian0s!',
  '2MtB4Fun!',
  '2Hard4Me!',
  '2Good2me!',
  '2GZ5i@6p$yzF',
  '2Ek6UeD$GVZ4',
  '2EJagYne7ea$u',
  '2E@dik@3621@',
  '2D847b7!',
  '2Connect2!!',
  '2Aea163!',
  '24cET44s%w3RznYA^%#p',
  '24Fb37c!',
  '23!X6j0kC#U9N_gL',
  '22?Pat08!',
  '21Mai1938$',
  '20TiMcBdBpIiVs12!',
  '20June98!',
  '2009Volvoxc70!',
  '2!_8Vjs1YQ35#6Jq',
  '1XD6#QjHA3!7Y_Kl',
  '1Startrack1!',
  '1Sn0wSt1$',
  '1LLmat1c!',
  '1Jeremy1!',
  '1Global2!',
  '1Ethel1!',
  '1Esu591772$',
  '1AJU!_Sk0Q#cjr8a',
  '19State82!',
  '19Jun2006#',
  '19Esther48!',
  '1988JonnyBlaze09666@T1MoN2009',
  '16lMu#9_7b0QZEBp',
  '15Jun04!',
  '13Charter13!',
  '123SeX666@1',
  '123123Knapfl1!',
  '10Pasjac11?',
  '10Hastings66!',
  '105H.a.l.i.d.a.1960!',
  '0m6#Ffo2BJp_39vH',
  '0ldMan72!22',
  '0_Bgw#8lPrtXaD!f',
  '0Emqug4C_A5L6f!y',
  '0Cedb74!',
  '09kdYt2#',
  '09KNBo6_n#3C!87q',
  '08Feb77!',
  '08Bh#zV!3_Fd7yQv',
  '07Chicag0!!',
  '040794Jz&o4o7&Rd$$',
  '01k6f9Cjt!zv5sE#',
  '01Mar2010!',
  '0#7Bf1E_Xz!QvI9P',
  '.p_m5BSb!74KNEF',
  '.YL38Jt#M46xzZ!d',
  '.G0CELKq2_s!w8mo',
  '.Cn56#bjuq90v71s',
  '..C97a626a#$..',
  '*o*p$GNvAl&I0g7N5G!G',
  '*Nhan@1090#',
  '*KrIs*21!',
  '*D4g3l4n#',
  '*13@Jv20@',
  '&2wVa7%1',
  '&&wdXabuSc7&b*QDex_6B*5v?e8V',
  '%YNaVuNyqy8A#y',
  '%AE2yme7A#ETu',
  '%A@APyta2u%u9A',
  '$va8RViBY2X#GRff',
  '$eGuPAU3Y5e$A',
  '$avY9AbYsY9y@a',
  '$aBEr9!0',
  '$Nikita1998$',
  '$Ne1469$',
  '$Junior6667$',
  '$JGspHyL6@wV5ecY',
  '$Hrl627$',
  '$Ernie1$',
  '$Bea341$',
  '$5Gam0&jah2UfHouu^r',
  '$$C354al76!$$',
  '#x3g48I!0wy1K_P',
  '#uR_kfp9tJ0T!4H',
  '#s3V$j8g!',
  '#a3Sk8!m5g2',
  '#Yz_u0n!Z94mI25d',
  '#X1u6H3ztvl!P_Gd',
  '#X12!gU8Mji_PrlE',
  '#Uve5USA%uqUva',
  '#Uno@*2008*@Z',
  '#Tineke1#',
  '#Rmrcosta84#',
  '#Or33216#',
  '#J8z9!5s7_ceX3bl',
  '#Gilbert19!',
  '#Fx40qK591Ada!bQ',
  '#Friedman123#',
  '#B1dd?2010!cbd',
  '#Asmaa2007#',
  '#AirBus_A-380#',
  '#6h2d4FK_0Ob8!G5',
  '#5R3Ia6Vje4!hNEu',
  '#4A_7rpY3cN!1mTi',
  '#24PS_ab8R!Q91rq',
  '#1NEpss2#',
  '#1NEpass2#',
  '#0ICu812!',
  '!y7aqU3a6u3u$U',
  '!slat8rmoB_7f54#',
  '!pR_hJ6#8s594g1k',
  '!hc0nEhc0L?',
  '!X2x4357zda#wjD_',
  '!Ujv15#7n_2DAaJI',
  '!Qazse4$',
  '!Qerty09!',
  '!QAZxsw2#EDC',
  '!Q2w3e$R',
  '!Q2w#E4r%T6y',
  '!Malak13s!',
  '!M$suX2!',
  '!LBmj3kyx5#UascA',
  '!KpFHNnQ79#_68oy',
  '!Jf7nHbg5U#R8Y2i',
  '!HSnxiCtVy#A9_X1',
  '!GqA7_9rmwk2#5i',
  '!G7A#bo0nj_8Y4Hm',
  '!Ek10jtv!',
  '!Dfcbkbcr123$',
  '!Dalexus_1983!',
  '!Crz0D_#4tMqg28P',
  '!BonaFide22!',
  '!Bh0Ky#_IpO67ex5',
  '!B6TnADvM9Rj8Z#2',
  '!9B#v0nh2mMs_P',
  '!5pP9KdSB8c_Ts#',
  '!5fQla490#gt7UHy',
  '!4E#kp7^',
  '!22SvaD!6A!',
  '!!Jed02?',
  '!!JUni22!!',
];
